var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actor-query-options query-options columns" },
    [
      _c(
        "div",
        { staticClass: "column is-5 is-left" },
        [
          _c("search-option-input-text", {
            attrs: {
              "on-enter": _vm.onSearch,
              autofocus: true,
              placeholder: _vm.$t("actors.search.placeholder"),
            },
            model: {
              value: _vm.options,
              callback: function ($$v) {
                _vm.options = $$v
              },
              expression: "options",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }